import { render, staticRenderFns } from "./TheCalendar2.vue?vue&type=template&id=3201ad94&scoped=true"
import script from "./TheCalendar2.vue?vue&type=script&lang=js"
export * from "./TheCalendar2.vue?vue&type=script&lang=js"
import style0 from "./TheCalendar2.vue?vue&type=style&index=0&id=3201ad94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3201ad94",
  null
  
)

export default component.exports